<!-- @format -->

<h3 #h3 class="ui primary header">
	{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="ui basic segment" *ngIf="successMsg || errorMsg">
	<esl-message-toast [(message)]="errorMsg"></esl-message-toast>
	<esl-message-toast [(message)]="successMsg" [messageType]="'success'"></esl-message-toast>
</div>
<div class="content">
	<div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
		<form class="ui form" [formGroup]="companyCEOForm">
			<div class="ui basic section">
				<h2 class="ui head">CEO Information</h2>
				<div class="ui divider"></div>

				<div
					class="field"
					[ngClass]="displayFieldCss('ceoName')"
					appMargin
					marginB="15px"
				>
					<label class="required">Name of CEO</label>
					<input type="text" formControlName="ceoName" />

					<app-field-error-display
						[displayError]="isFieldValid('ceoName')"
						errorMsg="Please provide detail"
					>
					</app-field-error-display>
				</div>

				<div
					class="field"
					[ngClass]="displayFieldCss('ceoContactEmail')"
					appMargin
					marginB="15px"
				>
					<label class="required">Email Address</label>
					<input type="text" formControlName="ceoContactEmail" />

					<app-field-error-display
						[displayError]="isFieldValid('ceoContactEmail')"
						errorMsg="Please provide detail"
					>
					</app-field-error-display>
				</div>

				<div
					class="field"
					[ngClass]="displayFieldCss('ceoContactPhone')"
					appMargin
					marginB="15px"
				>
					<label class="required">Phone Number</label>
					<input type="text" formControlName="ceoContactPhone" />

					<app-field-error-display
						[displayError]="isFieldValid('ceoContactPhone')"
						errorMsg="Please provide detail"
					>
					</app-field-error-display>
				</div>
			</div>
		</form>
	</div>
</div>

<div class="actions" style="background: transparent; border: none">
	<button class="ui basic primary button" (click)="modal.deny(undefined)">
		Close
	</button>
	<button
		class="ui primary button"
		[ngClass]="{ yellow: pending }"
		[disabled]="pending || !companyCEOForm.valid"
		(click)="update()"
		autofocus
	>
		Done
	</button>
</div>
